<template>
  <div class="RollingSegment--Settings" v-loading="isLoading">
    <el-row>
      <el-col :span="12">
        <el-form-item
          :label="$t('CampaignForm_Segments_RollingSegment_Title')"
          prop="rolling_segment_id"
        >
          <div class="RollingSegment--SelectRow">
            <el-select
              v-model="segment"
              class="RollingSegment--Select"
              :class="{
                'RollingSegment--SelectIsDisabled': isSelectedDisabled
              }"
              :filterable="true"
              :placeholder="
                $t('CampaignForm_Segments_RollingSegment_ChooseSegment')
              "
            >
              <el-option
                v-for="s in selectVariants"
                :key="s.id"
                :label="s.label"
                :value="s.id"
                :disabled="s.disabled"
              >
                <template v-if="s.disabled">
                  <el-tooltip
                    :content="
                      $t(
                        'CampaignForm_Segments_RollingSegment_Disabled_Tooltip'
                      )
                    "
                    placement="top"
                    effect="dark"
                  >
                    <span class="RollingSegment--DisabledOption">{{
                      s.label
                    }}</span>
                  </el-tooltip>
                </template>
              </el-option>
            </el-select>
            <el-tooltip
              v-if="isSelectedDisabled"
              :content="
                $t('CampaignForm_Segments_RollingSegment_Disabled_Tooltip')
              "
              placement="top"
              effect="dark"
            >
              <i
                class="el-icon-info RollingSegment--DisabledInfo"
                data-qa="rolling-segment-disabled-info"
              />
            </el-tooltip>
          </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row class="RollingSegment--CalculationInfo" v-if="calculationMessage">
      <span
        class="RollingSegment--CalculationInfoTitle"
        v-if="calculationMessage.title"
      >
        {{ calculationMessage.title }}
      </span>
      <span class="RollingSegment--CalculationInfoMessage">
        {{ calculationMessage.message }}
      </span>
    </el-row>
  </div>
</template>

<script>
import { projectEndpoint, projectTimezoneDate } from '@/core/helpers'
import RestApi from '@/core/services/RestApi'
import { find } from 'lodash'
import { isSegmentDisabled } from '@/modules/audiences/enum/SegmentSyncStatusEnum'

export default {
  name: 'RollingSegment',

  props: {
    value: {
      type: Number
    }
  },

  data: function() {
    return {
      segments: [],
      isLoading: false
    }
  },

  computed: {
    fetchEndpoint() {
      const params = {
        type: 1,
        'per-page': 500,
        exclude_disabled: 1
      }

      if (this.value) {
        params.include_id = this.value
      }

      return projectEndpoint({
        method: 'get',
        url: `segments`,
        params
      })
    },

    segment: {
      get() {
        return this.value == null ? this.value : Number(this.value)
      },
      set(value) {
        this.$emit('input', value)
      }
    },

    currentSegment() {
      if (!this.value) return undefined

      return find(this.segments, i => Number(i.id) === Number(this.value))
    },

    isSelectedDisabled() {
      return (
        !!this.currentSegment && isSegmentDisabled(this.currentSegment.status)
      )
    },

    calculationMessage() {
      if (!this.currentSegment) return undefined

      if (!this.currentSegment.last_sync_time) {
        return {
          message: this.$t(
            'CampaignForm_Segments_RollingSegment_LastCalculation_CalculationWarning'
          )
        }
      }

      return {
        title: this.$t(
          'CampaignForm_Segments_RollingSegment_LastCalculation_Title'
        ),
        message: projectTimezoneDate(this.currentSegment.last_sync_time).format(
          'YYYY-MM-DD HH:mm'
        )
      }
    },

    selectVariants() {
      return this.segments.map(s => {
        return {
          id: Number(s.id),
          label: s.title,
          disabled: isSegmentDisabled(s.status)
        }
      })
    }
  },

  mounted() {
    this.isLoading = true
    RestApi(this.fetchEndpoint).then(({ data }) => {
      this.segments = data
      this.isLoading = false
    })
  }
}
</script>

<style scoped>
.RollingSegment--SelectRow {
  display: flex;
  align-items: center;
  gap: 8px;
}

.RollingSegment--Select {
  flex: 1;
  min-width: 0;
}

.RollingSegment--SelectIsDisabled >>> .el-input__inner {
  color: #c0c4cc;
}

.RollingSegment--DisabledInfo {
  color: #909399;
  cursor: help;
  font-size: 16px;
  flex-shrink: 0;
}

.RollingSegment--CalculationInfo {
  padding: 0 10px;
  display: grid;
}

.RollingSegment--CalculationInfoTitle {
  font-size: 14px;
  height: 30px;
  line-height: 30px;
}

.RollingSegment--CalculationInfoMessage {
  color: #7e8596;
  font-size: 12px;
}

.RollingSegment--DisabledOption {
  color: #c0c4cc;
}
</style>



// WEBPACK FOOTER //
// src/modules/campaign-manage/components/segment/RollingSegment.vue